import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
:root {
    /** @todo find a better way to do
    this instead of giving the row label an arbitrary percent */
}
.row-label {
    display: block;
    width: calc(100% - 8px);
    padding: 12px 0 12px 25px;
}
.row-label.etf {
    padding-left: 0;
}
.row-label :global(.title-link) {
    display: block;
    text-decoration: none;
    font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
    font-size: 16px;
    color: #3b3b3b;
    cursor: pointer;
}
.row-label :global(.title-link) .name {
    color: #086ea1;
}
.row-label:hover :global(.title-link) .name {
    text-decoration: underline;
}
.ticker-row {
    font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
    font-size: 12px;
}
.ticker-row div,
img {
    display: inline-block;
}
.title-link img {
    padding-left: 2px;
    margin-top: -2px;
    vertical-align: middle;
}
.title-link img.lock {
    width: 12px;
    position: relative;
    top: -2px;
}
.closed-fund {
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: calc(8px * 2);
}
.inception-date {
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: calc(8px * 2);
}
`;

export default styles;